import React, { useEffect, useState } from 'react'
import {
	BarChart,
	Bar,
	XAxis,
	YAxis,
	CartesianGrid,
	Tooltip,
	Legend,
	ResponsiveContainer,
} from 'recharts'

export default function ArticleTypeChart({ articleList }) {
	const [articleTypeCounter, setArticleTypeCounter] = useState([])

	const barColors = ['#1f77b4', '#ff7f0e', '#2ca02c', '#962c28', '#a02c79']

	useEffect(() => {
		// Zählen
		const counts = articleList.reduce((acc, a) => {
			const key = a.articleType ?? 'Unknown'
			acc[key] = (acc[key] || 0) + (Number(a.quantity) || 0)
			return acc
		}, {})

		// "Others" nur behalten, wenn > 0
		if (counts.Others === 0) delete counts.Others

		// Ein Datapoint mit Keys = Serien
		setArticleTypeCounter([counts])
	}, [articleList]) // <— wichtig: kein async, und an Prop binden

	if (articleTypeCounter.length === 0) {
		return (
			<div className='flex justify-center items-center p-6 mt-8'>
				<h3 className='text-xl font-medium text-gray-700 animate-pulse'>
					Loading Charts...
				</h3>
			</div>
		)
	}

	const keys = Object.keys(articleTypeCounter[0])

	return (
		<div className='chart'>
			<h3 className='chartTitle'>Article Types Chart</h3>
			{/* ResponsiveContainer braucht eine definierte Höhe im Parent */}
			<div style={{ width: '100%', height: 320 }}>
				<ResponsiveContainer width='100%' height='100%'>
					<BarChart data={articleTypeCounter} margin={{ top: 20 }}>
						{keys.map((k, i) => (
							<Bar
								key={k}
								dataKey={k}
								fill={barColors[i % barColors.length]}
								label={{ position: 'top' }}
							/>
						))}
						<CartesianGrid strokeDasharray='3 3' />
						{/* Du hast kein "name"-Feld im Datensatz; XAxis hier optional */}
						<XAxis dataKey='__dummy' hide />
						<YAxis />
						<Tooltip cursor={{ fill: 'transparent' }} />
						<Legend />
					</BarChart>
				</ResponsiveContainer>
			</div>
		</div>
	)
}
